import React from 'react'
import DataTable from "react-data-table-component";
import { useSelector } from 'react-redux'
import { RemoveFollowerIcon } from '../../AppIcons';

export const CampaignFollowers = (props) => {
    const {removeFollower,selectedMembersData,pending}=props
	const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
    const theme = aaaSelected ? "dark" : "";


    const customRoleSort = (rowA, rowB, sortDirection) => {
        // Implement your custom sorting logic here
        // For example, you can compare the roles alphabetically
        const roleA = rowA?.role?.toLowerCase();
        const roleB = rowB?.role?.toLowerCase();
        if (roleA < roleB) return sortDirection === 'asc' ? -1 : 1;
        if (roleA > roleB) return sortDirection === 'asc' ? 1 : -1;
        return 0;
      };

      const customNameSort = (rowA, rowB, sortDirection) => {
        // Implement your custom sorting logic here
        // For example, you can compare the names alphabetically
        const nameA = rowA?.owner ? rowA?.name : rowA?.firstName + " " + rowA?.lastName;
        const nameB = rowB?.owner ? rowB?.name : rowB?.firstName + " " + rowB?.lastName;
      
        if (nameA < nameB) return sortDirection === 'asc' ? -1 : 1;
        if (nameA > nameB) return sortDirection === 'asc' ? 1 : -1;
        return 0;
      };
      

    const selectedColumns = [
        {
            id: 'customerUser.name',
            name: 'Name',
            selector: (row) => row.owner ? row.name + "(Owner)" : row.firstName + " " + row.lastName,
            sortable:true,
            reorder: true,
        },
        {
            name: 'Role',
            id: 'project.Role',
            sortFunction: customRoleSort,
            selector: (row) => <>{row['role']} </>,
            reorder: true,
        }, {
            name: "",
            id: 'project.action',
            selector: (row) => row?.owner ? "" : <button type="button" className="remove-btn" onClick={() => { removeFollower(row?.userId) }}>
               {RemoveFollowerIcon}
                Remove
            </button>
        }

    ]


    return (
        <div className="table-responsive ">
            <div className="datatable-block ">
                <DataTable
                    columns={selectedColumns}
                    data={selectedMembersData}
                    defaultSortFieldId={1}
                    responsive
                    striped
                    selectableRowsHighlight
                    fixedHeader
                    theme={theme}
                    progressPending={pending}
                />
            </div>
        </div>
    )
}
